import posthog from 'posthog-js'

export function isFeatureFlagEnabled(flag: string): boolean {
  if (process.env.NODE_ENV !== 'production') return true
  return posthog.isFeatureEnabled(flag) ?? false
}
